import React from 'react';
export function FuturePacingSection() {
  return <section className="py-16 md:py-24 bg-white relative overflow-hidden" data-id="element-92">
      <div className="max-w-5xl mx-auto px-5 md:px-8" data-id="element-93">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-94">
          <div className="md:w-1/2 space-y-8" data-id="element-95">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-dark" data-id="element-96">
              Imagine Daqui a 7 Dias
            </h2>

            <p className="text-lg text-brand-text/80 leading-relaxed" data-id="element-97">
              Você acorda. Vai até o armário. Pega aquela calça que estava
              apertada. Respira. Veste. E percebe que ela fecha com mais
              facilidade.
            </p>

            <div className="bg-brand-pink/30 p-6 rounded-2xl border-l-4 border-brand-pink" data-id="element-98">
              <p className="text-xl font-serif font-medium text-brand-dark italic" data-id="element-99">
                "Não porque você sofreu. Não porque passou fome. Mas porque
                finalmente começou a tratar o problema certo."
              </p>
            </div>

            <div className="space-y-2" data-id="element-100">
              <p className="text-lg font-medium text-brand-sage-dark flex items-center gap-2" data-id="element-101">
                <span className="w-2 h-2 rounded-full bg-brand-sage-dark" data-id="element-102"></span>{' '}
                Menos peso.
              </p>
              <p className="text-lg font-medium text-brand-sage-dark flex items-center gap-2" data-id="element-103">
                <span className="w-2 h-2 rounded-full bg-brand-sage-dark" data-id="element-104"></span>{' '}
                Menos estufamento.
              </p>
              <p className="text-lg font-medium text-brand-sage-dark flex items-center gap-2" data-id="element-105">
                <span className="w-2 h-2 rounded-full bg-brand-sage-dark" data-id="element-106"></span>{' '}
                Mais controle.
              </p>
              <p className="text-lg font-medium text-brand-sage-dark flex items-center gap-2" data-id="element-107">
                <span className="w-2 h-2 rounded-full bg-brand-sage-dark" data-id="element-108"></span>{' '}
                Mais leveza.
              </p>
              <p className="text-xl font-bold text-brand-dark flex items-center gap-2 mt-4" data-id="element-109">
                <span className="w-2 h-2 rounded-full bg-brand-dark" data-id="element-110"></span>{' '}
                Mais você.
              </p>
            </div>
          </div>

          <div className="md:w-1/2" data-id="element-111">
            <img src="https://cdn.magicpatterns.com/uploads/5XWDTEe7UthYDohPr89eCe/magnific_antes-imagen-realista-est_swu07Y8l8e.png" alt="Sensação de leveza e bem-estar" className="rounded-2xl shadow-xl w-full object-cover border-4 border-white" data-id="element-112" />
          </div>
        </div>
      </div>
    </section>;
}